import { Path } from 'react-hook-form';
import { CloseBrothersForm } from '../../queries/schema/carFinance.schema';

export type { StepConfig } from '../shared/types';

export const TOTAL_STEPS = 6;

export const STEP_1_FIELDS: Path<CloseBrothersForm>[] = [
  'loanDetails.cashDeposit',
  'personalDetails.title',
  'personalDetails.firstName',
  'personalDetails.surname',
  'personalDetails.phone',
  'personalDetails.email',
];

export const STEP_2_FIELDS: Path<CloseBrothersForm>[] = [
  'personalDetails.dateOfBirth',
  'personalDetails.countryOrigin',
  'personalDetails.gender',
  'personalDetails.maritalStatus',
  'personalDetails.ppsNumber',
  'personalDetails.numberOfDependents',
  'personalDetails.tradeInRegPlate',
];

export const STEP_3_FIELDS: Path<CloseBrothersForm>[] = [
  'currentAddress.residentialStatus',
  'currentAddress.addressLine1',
  'currentAddress.town',
  'currentAddress.county',
  'currentAddress.timeAtCurrentAddress.years',
];

export const STEP_4_FIELDS: Path<CloseBrothersForm>[] = [
  'employmentDetails.industry',
  'employmentDetails.occupation',
  'employmentDetails.type',
  'employmentDetails.status',
  'employmentDetails.employerName',
  'employmentDetails.employerPhone',
  'employmentDetails.employerAddress.addressLine1',
  'employmentDetails.employerAddress.town',
  'employmentDetails.employerAddress.county',
  'employmentDetails.timeWithEmployer.years',
];

export const STEP_5_FIELDS: Path<CloseBrothersForm>[] = [
  'bankingDetails.income',
  'bankingDetails.monthlyMortgageRent',
  'bankingDetails.bankName',
  'bankingDetails.accountType',
  'bankingDetails.yearsWithBank',
];
